import dayjs from 'common/config/dayjs.config';
import { IOrderHistoryModel } from 'entities/OrderHistory/OrderHistory.models';

const reorderMaxAvailableHoursInterval = 24;

export const isOrderRateTimeExpired = (orderHistoryItem: IOrderHistoryModel | null): boolean => {
  const { pickedUpAt } = orderHistoryItem || {};
  return dayjs().diff(dayjs(pickedUpAt), 'hours') > reorderMaxAvailableHoursInterval;
};
